import { RootState } from '../../../../utils/type';

export const selectVendorChargingReport = (state: RootState) => state.vendorChargingReport.data;
export const selectVendorChargingReportLoading = (state: RootState) => state.vendorChargingReport.loading;
export const selectVendorChargingReportError = (state: RootState) => state.vendorChargingReport.error;
export const selectVendorChargingReportDownloadError = (state: RootState) => state.vendorChargingReport.downloadError;
